/**
 * Префикс ключей персистентности (tech-spec §10, §16.3).
 * Единый namespace для localStorage и VK Storage.
 */
export const STORAGE_NAMESPACE = 'delivery_vk_app';

export const STORAGE_RECORD_KEYS = {
  onboarding_complete: 'onboarding_complete',
  selected_courier_id: 'selected_courier_id',
  passes_balance: 'passes_balance',
  player_economy: 'player_economy',
  player_economy_h0: 'player_economy_h0',
  player_economy_h1: 'player_economy_h1',
  player_economy_h2: 'player_economy_h2',
  player_economy_h3: 'player_economy_h3',
  player_economy_h4: 'player_economy_h4',
  player_economy_h5: 'player_economy_h5',
  player_economy_h6: 'player_economy_h6',
  player_economy_h7: 'player_economy_h7',
  audio_muted: 'audio_muted',
  audio_level: 'audio_level',
} as const;

export type StorageRecordKey = keyof typeof STORAGE_RECORD_KEYS;

export const PLAYER_ECONOMY_HISTORY_CHUNK_KEYS = [
  'player_economy_h0',
  'player_economy_h1',
  'player_economy_h2',
  'player_economy_h3',
  'player_economy_h4',
  'player_economy_h5',
  'player_economy_h6',
  'player_economy_h7',
] as const satisfies readonly StorageRecordKey[];

/**
 * Строковый ключ для localStorage и VK Storage.
 * VK допускает только [a-zA-Z0-9_-] — двоеточие в namespace недопустимо.
 */
export function toStorageStringKey(recordKey: StorageRecordKey): string {
  return `${STORAGE_NAMESPACE}_${STORAGE_RECORD_KEYS[recordKey]}`;
}
